<template>
<div>

    Please view, print and/or save the documents linked below.

    <m-signature-packet-documents
        :meta_data="meta_data"
    />

    <m-legal-agreement
            :type="agreement_type"
            :organization_id="organization_id"
            :organization_label="organization_label"
            :value="value"
            v-on:input="$emit('input',$event)"
            ref="legal_cb"
        />


</div>
</template>

<script>
export default {
    props: {
        meta_data: {
            type: Array,
            default: function() { return []; },
        },

        value: {
            type: Boolean,
            default: function() { return false; },
        },

        agreement_type: {
            type: String,
            default: function() { return 'accept-above-agreements'}
        },

        organization_id: {
            type: String,
            default: function() { return null; }
        },

        organization_label: {
            type: String,
            default: function() { return null; }
        },
    },

    methods: {
        getSpecimen() {
            return this.$refs['legal_cb'].getSpecimen();
        },
    },
}
</script>

<style lang="scss" scoped>
</style>